
      <div class="carousell-fullwidth-container pl-1 pr-1">
        <app-carousel [slides]="slides" [slideHeight]="'472px'"></app-carousel>
      </div>

